import React from "react";
import styles from "./StatGrid.module.css";

export interface StatGridProps {
  children: React.ReactNode;
}

/**
 * Responsive grid for laying out StatCard tiles in a page-level metrics row.
 * Four columns down to two, then one, as the viewport narrows. A dedicated
 * component rather than reusing MetaGrid, which is fixed at two columns —
 * not a clean fit for a 4-up stat row.
 */
const StatGrid = ({ children }: StatGridProps): React.ReactElement => {
  return <div className={styles.grid}>{children}</div>;
};

export default StatGrid;
